export type Listener<Event> = (event: Event) => void;

export class EventBus<Event> {
  public paused: boolean;

  constructor(private listeners: Listener<Event>[] = []) {
    this.paused = false;
  }

  remove(listener: Listener<Event>) {
    this.listeners = this.listeners.filter(
      (listenerIte) => listenerIte !== listener
    );
  }

  subscribe(listener: Listener<Event>) {
    this.listeners.push(listener);
    return {
      unsubscribe: () => this.remove(listener),
    };
  }

  send(event: Event) {
    if (this.paused) return;
    this.listeners.forEach((listener) => listener(event));
  }
}
